<div class="modal-header border-0 pb-0">
  <h4 class="modal-title text-light-black fw-600" id="modal-title">
    <i [class]="icon" [class]="iconColor" class="me-2"></i>
    {{ title }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCancel()"
  ></button>
</div>

<div class="modal-body py-4">
  <p class="text-light-black mb-0" [innerHTML]="message"></p>
</div>

<div class="modal-footer border-0 pt-0">
  <button
    type="button"
    class="btn fw-600"
    [class]="cancelButtonClass"
    (click)="onCancel()"
  >
    {{ cancelText }}
  </button>
  <button
    type="button"
    class="btn fw-600 ms-2"
    [class]="confirmButtonClass"
    (click)="onConfirm()"
  >
    {{ confirmText }}
  </button>
</div>
